import React, { useEffect, useState, useContext } from "react";
import "../admin/admin.css";
import { Link, Outlet, useHref, useNavigate, useParams } from "react-router-dom";
import Application from "./StateContext/Application";
import '../Users/pages/innercss.css'

import { host } from '../../path'
import { logout, maharashtra } from "../../public/LoginImages/importimages";

const AdminNavbar = () => {
  const navigate = useNavigate("");
  const statecalls = useContext(Application);
  const { Usermenu } = statecalls;
  const [panel, setpanel] = useState("showpanel");
  let check = localStorage.getItem("Token");

  const [renderdata, SetRenderdata] = useState([]);
  const [loading, setloading] = useState(true)
  const para = useHref()
  useEffect(() => {
    try {
      if (!check) {
        navigate('/adminlogin')
        window.location.href = '/adminlogin'
      }
      getmenu()
    } catch (error) {
      console.error('Error in AdminNavbar useEffect:', error);
    }
  }, [])

  const getmenu = async () => {
    try {
      const data = await Usermenu();
      SetRenderdata(await data);
      setloading(false);
      if (data) {
        console.log("data",data);
        let validationlink = window.location.pathname
        if (!data || typeof data !== "object") {
          console.error("Invalid data:", data);
          return [];
      }
  
      const menuArray = Array.isArray(data.result) ? data.result : [];
        let check = menuArray.filter((check) => {
          
          return (
            check.Link === validationlink
          )
        });
        if (check[0] === undefined) {
          alert('you are not allowed to access this link')
          navigate(data[0].Link)
        }
      }
    } catch (error) {
      console.error('Error in AdminNavbar getmenu:', error);
    }
  }
  const sidepanel = () => {
    if (panel === "showpanel") {
      setpanel("panel");
    } else {
      setpanel("showpanel");
    }
  };
  const showoptions = (e) => {
    try {
      let k = document.getElementById(e.currentTarget.value);
      if (k == null) { return }
      if (k.style.display == 'none') {
        k.style.display = 'block'
      }
      else {
        k.style.display = 'none'
      }
    } catch (error) {
      console.error('Error in AdminNavbar showoptions:', error);
    }

  }
  var audio = new Audio('https://commondatastorage.googleapis.com/codeskulptor-assets/Collision8-Bit.ogg');



  return (
    <>
      <div style={{ display: "flex" }}>
        {/* This is sidePanel */}
        <div
          className={panel}
          style={{
            boxShadow: "2px",
            animation: "fadeIn 1s ease-in-out",
          }}
        >
          <div
            className="card"
            style={{
              width: "16rem",
              height: "120%",
              display: "flex",
              justifyContent: "center",
              background: 'linear-gradient(to bottom, #e73d26 10%,#e73d26 50%,#e73d26 8%,#d4e01c 100%)',
              border: "none",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                padding: "1rem",
              }}
            >
              <img
                src={maharashtra}
                className="card-img-top"
                alt="..."
                style={{ width: "6rem", height: "6rem", alignSelf: "center" }}
              />
            </div>
            <ul className="list-group list-group-flush" style={{ border: "none" }}>
              {
                loading ? (
                  <div className="loader"></div>
                ) : (
                  Array.isArray(renderdata.result) ?
                    renderdata.result.map((e) => {
                      if (!e.Summenuid) {
                        return (
                          <li className="hovereffect" key={e.Menu_ID} value={e.Menu_ID} onClick={(e) => showoptions(e)}>
                            <Link to={e.Link} className="list-group-item  listchange" >
                              <i className={e.icons + " mx-2"} aria-hidden="true"></i>
                              <span>
                                {e.Menu_Name}
                              </span>
                              <ul id={e.Menu_ID} style={{ display: 'none' }}>
                                {renderdata.result.map((x) => {
                                  if (e.Menu_ID === x.Summenuid) {

                                    return (

                                      <Link key={x.Link} to={x.Link} style={{ textDecoration: 'none', fontSize: '12px', color: "black" }}><li className="hovereffect" style={{ paddingLeft: "15px" }}>{x.Menu_Name}</li></Link>
                                    )
                                  }
                                })}
                              </ul>
                            </Link>
                          </li>
                        );
                      }

                    }) : <a key={5678} style={{ color: 'white' }}>Kindly Refresh</a>
                )
              }
              <Link to='/AdminLogin'>
                <button
                  className="mx-5 my-5 btn1 hovereffect"
                  style={{ border: "1px solid", padding: '5px' }}
                  onClick={() => localStorage.clear()}
                >
                  <b style={{ fontSize: "15px" }}>
                    <img
                      style={{ height: "2rem" }}
                      src={logout}
                      alt="Logout Icon"
                    />
                    &nbsp;&nbsp;&nbsp;Logout
                  </b>
                </button>
              </Link>
            </ul>


            <div className="card-body">

            </div>
          </div>
        </div>
        {/* this is navebar */}

        <div style={{ width: "100vw" }}>
          <nav
            className="navbar navbar-static-top"
            id="imgcss"
            style={{
              backgroundColor: "white",
              display: "flex",
              flexWrap: "wrap",
            }}
          >
            <a
              onClick={sidepanel}
              href="#"
              className="sidebar-toggle"
              data-toggle="push-menu"
              role="button"
              style={{
                color: "red",
                textDecoration: "none",
                marginLeft: "1rem",
              }}
            >
              <i className="fa-solid fa-sliders"></i>
              <span style={{ backgroundColor: "red", color: "white", padding: "5px", marginLeft: "5px", border: "1px", border: "none", borderRadius: "8px" }}> {para.slice(1)} </span>
            </a>
            <div style={{color:"red"}}>
            <i className="fa-solid fa-user"></i>
            <span className="mx-3" style={{ backgroundColor: "red", color: "white", padding: "5px", marginLeft: "5px", border: "1px", border: "none", borderRadius: "8px" }}>{renderdata? `Welcome ${renderdata?.Data?.FullName}`:''}</span>
            </div>
          </nav>
          <Outlet />
        </div>
      </div>
    </>
  );
};

export default AdminNavbar;
